function priorityByRule(rule, property) {
    var _rule_style;
    return ((_rule_style = rule.style) == null ? void 0 : _rule_style.getPropertyPriority(property)) === "important" ? 100000 : 0;
}
export { priorityByRule };
